import React from "react"
import { cardHighlight, flexBox, maxLines } from "style/style_snippets"
import PropTypes from "prop-types"
// import Img from "gatsby-image"
import { GatsbyImage } from "gatsby-plugin-image"
import { navigate } from "gatsby"
import {
  ArticleAuthorAndDate,
  ArticleReadingTime,
  ArticleTitle,
} from "components/shared/ArticleSnippets"
import { Grid, Typography } from "@mui/material"

const newsCardStyle = {
  container: {
    height: "590px",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "290px 1fr",
    cursor: "pointer",
    ...cardHighlight,
  },

  content: {
    height: "100%",
    padding: "25px 32px 30px 28px ",

    contentWrapper: {
      ...flexBox.column,
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },

    description: {
      marginTop: "20px",
      display: "-webkit-box",
      ...maxLines(4),
    },
  },
}

const NewsCard = ({
  slug,
  title,
  author,
  date,
  cover,
  featuredImage,
  readingTime,
  prevUrl,
  grid,
  imgCredits,
}) => {
  let { fullWidth } = featuredImage?.childImageSharp
  return (
    <Grid item {...grid} onClick={() => navigate(slug, { state: { prevUrl } })}>
      <div css={newsCardStyle.container} aria-hidden="true">
        <GatsbyImage alt={imgCredits} image={featuredImage?.childImageSharp?.gatsbyImageData} />

        <div css={newsCardStyle.content}>
          <div css={newsCardStyle.content.contentWrapper}>
            <ArticleTitle {...{ title, additionalCss: { ...maxLines(2) } }} />

            <ArticleAuthorAndDate
              {...{ author, date, additionalCss: { marginTop: "5px" } }}
            />

            <ArticleReadingTime
              {...{ readingTime, additionalCss: { marginTop: "6px" } }}
            />
            <Typography
              variant={"body1"}
              css={newsCardStyle.content.description}
            >
              {cover}
            </Typography>
          </div>
        </div>
      </div>
    </Grid>
  )
}

NewsCard.propTypes = {
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  featuredImage: PropTypes.object.isRequired,
  readingTime: PropTypes.string.isRequired,
  prevUrl: PropTypes.string.isRequired,
}

export default NewsCard
